var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcFantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5117_22006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0H52V44H32C18.7452 44 8 33.2548 8 20V0Z",
    fill: "#13B5EC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5117_22006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5117_22006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40C39.9411 40 48 31.9411 48 22C48 12.0589 39.9411 4 30 4C20.0589 4 12 12.0589 12 22C12 31.9411 20.0589 40 30 40Z",
    fill: "#13B5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.35 18.5125L35.4 16.15V20.875L31.35 18.5125ZM35.4 28.6375L30 31.7875L24.6 28.6375V23.125L30 26.275L35.4 23.125V28.6375ZM24.6 16.15L28.65 18.5125L24.6 20.875V16.15ZM30.675 19.6375L34.725 22L30.675 24.3625V19.6375ZM29.325 24.3625L25.275 22L29.325 19.6375V24.3625ZM34.725 15.025L30 17.725L25.275 15.025L30 12.2125L34.725 15.025ZM23.25 14.575V29.3125L30 33.1375L36.75 29.3125V14.575L30 10.75L23.25 14.575Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5117_22006",
    x: 0,
    y: -4,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5117_22006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5117_22006",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5117_22006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5117_22006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFantom);
export default __webpack_public_path__ + "static/media/icFantom.3192bbb333405eec11bd7a93f0df8784.svg";
export { ForwardRef as ReactComponent };